module.exports = __webpack_public_path__ + "img/app-screenshot.a8913dd1.jpg";